// extracted by mini-css-extract-plugin
module.exports = {"input":"Checkbox_input__1N6AO","label":"Checkbox_label__20hIR","span":"Checkbox_span__39a10"};